import React from 'react';

const Terms = () => {
  return (
    <div className="section-spacing bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-8" style={{ color: '#2C2C2C' }}>
            利用規約
          </h1>
          
          <div className="space-y-8 text-gray-700 leading-relaxed">
            <section>
              <p>
                この利用規約（以下、「本規約」といいます）は、さくらローカルビジネスサポート（以下、「当事業者」といいます）が提供するサービスの利用条件を定めるものです。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2C2C2C' }}>第1条（適用）</h2>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li>本規約は、当事業者が提供する全てのサービスに適用されます。</li>
                <li>利用者は、サービスの利用により、本規約に同意したものとみなします。</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2C2C2C' }}>第2条（サービス内容）</h2>
              <p className="mb-3">当事業者は、以下のサービスを提供します。</p>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li>Webサイトの企画・制作・運用</li>
                <li>SNSアカウントの運用代行</li>
                <li>マーケティング支援（Googleマップ最適化等）</li>
                <li>ビジネスコンサルティング</li>
                <li>その他関連サービス</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2C2C2C' }}>第3条（契約の成立）</h2>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li>サービスの契約は、利用者からのお申し込みを当事業者が承諾した時点で成立します。</li>
                <li>当事業者は、理由を問わずお申し込みをお断りする場合があります。</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2C2C2C' }}>第4条（料金および支払い）</h2>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li>料金は、契約時に提示する見積書に基づきます。</li>
                <li>支払い方法や支払い時期については、別途協議します。</li>
                <li>支払い後の返金には応じません。ただし、当事業者の責めに帰すべき事由がある場合はこの限りではありません。</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2C2C2C' }}>第5条（知的財産権）</h2>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li>当事業者が制作した成果物の著作権は、別途契約に定めがない限り、当事業者に帰属します。</li>
                <li>利用者は、成果物を事業目的で使用する権利を有します。</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2C2C2C' }}>第6条（秘密保持）</h2>
              <p>
                当事業者および利用者は、相手方の書面による事前の承諾なく、業務上知り得た情報を第三者に開示または漏洩してはなりません。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2C2C2C' }}>第7条（禁止事項）</h2>
              <p className="mb-3">利用者は、以下の行為をしてはなりません。</p>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li>法令または公序良俗に反する行為</li>
                <li>犯罪行為に関連する行為</li>
                <li>当事業者または第三者の知的財産権を侵害する行為</li>
                <li>当事業者のサービスの運営を妨げる行為</li>
                <li>その他、当事業者が不適切と判断する行為</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2C2C2C' }}>第8条（サービスの変更・中断）</h2>
              <p>
                当事業者は、利用者への事前通知なく、サービス内容の変更や提供の中断を行うことがあります。これにより生じた損害について、当事業者は一切の責任を負いません。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2C2C2C' }}>第9条（免責事項）</h2>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li>当事業者は、サービスの内容が利用者の期待に沿うことを保証するものではありません。</li>
                <li>当事業者は、天災地変、戦争、暴動、騒乱、ストライキその他の不可抗力による損害について、一切の責任を負いません。</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2C2C2C' }}>第10条（解約）</h2>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li>利用者は、事前に書面で通知することにより、契約を解約することができます。</li>
                <li>利用者が本規約に違反した場合、当事業者は何らの通知なく契約を解除することができます。</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2C2C2C' }}>第11条（規約の変更）</h2>
              <p>
                当事業者は、必要に応じて本規約を変更することがあります。変更後の規約は、当サイトに掲載した時点から効力を生じます。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2C2C2C' }}>第12条（準拠法および管轄裁判所）</h2>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li>本規約の解釈については、日本法を準拠法とします。</li>
                <li>本規約に関する紛争が生じた場合は、当事業者の本店所在地を管轄する裁判所を専属的合意管轄裁判所とします。</li>
              </ol>
            </section>

            <div className="pt-8 border-t">
              <p className="text-sm text-gray-600">制定日：2025年1月1日</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;